module.exports = __webpack_public_path__ + "static/media/454A9251.f97e509c.jpg";